import StateObserver, { now, user } from 'src/StateObserver';
import PopupCheats, { Item } from '../cheats/PopupCheats';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { CheatData } from '../cheats/cheats.sequences';
import { closeAllPopups } from 'src/lib/popups/popupOpenClose';

const MATCH2_TREASURE_EXPRESS = 'match2 Treasure Express';

const list = () => {
  const cheats: Record<string, CheatData[]> = {};

  cheats[MATCH2_TREASURE_EXPRESS] = [
    {
      text: 'Reset Treasure Express',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_resetTreasureExpress();
        closeAllPopups();
      },
    },
    {
      text: 'Progress Treasure Express',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_progressTreasureExpress();
      },
    },
    {
      text: 'Treasure Express Easy',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_setTreasureExpressDifficulty('easy');
      },
    },
    {
      text: 'Treasure Express Normal',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_setTreasureExpressDifficulty('normal');
      },
    },
    {
      text: 'Treasure Express Hard',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_setTreasureExpressDifficulty('hard');
      },
    },
  ];

  return cheats;
};

const ui = (args: {
  key: string;
  popup: PopupCheats;
  item: Item;
  title: LangBitmapFontTextView;
  setting: CheatData[];
  parent: Item | null;
}) => {
  if (args.key !== MATCH2_TREASURE_EXPRESS) return;
  args.title.updateOpts({
    width: args.item.style.width - 40,
    height: 20,
    y: 8,
    align: 'center',
  });
  args.popup.createVerticalButtons(args.item, args.setting);
};

export const treasureExpressCheats = {
  list,
  ui,
};
